import React, { useEffect, useState } from "react";
// import { getLessonsByUser, updateLessonStatus } from "../../services/lessons";
import "../../styles/StudentLessons.css"; // Create a CSS file for custom styles
import {
  getLessonsByUser,
  updateLesson,
  updateLessonStatus,
} from "../../services/lessons";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { formatDuration } from "../../Components/custom/Helpers";
import {
  formatDate,
  formatTimeTo12HourFormat,
} from "../../Components/Helpers/Helper";
import { Dialog } from "primereact/dialog";
import { RadioButton } from "primereact/radiobutton";
import { toast } from "react-toastify";
import { useSearchParams } from "react-router-dom";

const StudentLessons = ({ userId, role }) => {
  let id = null;
  if (typeof window !== "undefined") {
    id = userId || localStorage.getItem("userId");
  }
  // const id = userId || localStorage.getItem("userId");
  const [lessons, setLessons] = useState([]);
  const [feedback, setFeedback] = useState([]); // Store feedback for each lesson
  const [chooseLessonTimeModalVisible, setChooseLessonTimeModalVisible] =
    useState(false);
  const [selectedLesson, setSelectedLesson] = useState({});
  const [proposedOptions, setProposedOptions] = useState([]);
  const [selectedTime, setSelectedTime] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const [toastShown, setToastShown] = useState(false);
  useEffect(() => {
    const fetchLessons = async () => {
      // const response = await getLessonsByUser(JSON.parse(role), id);
      const response = await getLessonsByUser(role, id);
      setLessons(response);
    };
    fetchLessons();
  }, [id, role]);
  useEffect(() => {
    const lessonId = Number(searchParams.get("lessonId"));
    if (searchParams.get("proposeOption") === "true" && lessonId) {
      const lesson = lessons.find((lesson) => lesson.id === lessonId);
      if (lesson) {
        if (lesson?.start_time && lesson?.status === "accepted") {
          if (!toastShown) {
            // ✅ Show toast only if it hasn't been shown before
            toast.warn("Lesson already scheduled");
            setToastShown(true); // ✅ Prevent future toasts
          }

          // ✅ Clear query params to prevent re-triggering on reload
          const newParams = new URLSearchParams(searchParams);
          newParams.delete("proposeOption");
          newParams.delete("lessonId");
          setSearchParams(newParams); // Assuming you're using React Router's useSearchParams

          return setChooseLessonTimeModalVisible(false);
        } else {
          setSelectedLesson(lesson);
          setProposedOptions(lesson.order?.proposed_schedule || []);
        }
      }
    }
  }, [searchParams, lessons]); // Include lessons to avoid stale data

  // Show the modal when selectedLesson is set
  useEffect(() => {
    if (selectedLesson) {
      setChooseLessonTimeModalVisible(true);
    }
  }, [selectedLesson]);
  const handleAction = async (lessonId, action) => {
    // Update the lesson status (accept/decline)
    await updateLessonStatus(lessonId, action, feedback[lessonId] || "");
    // Refresh lessons
    // const response = await getLessonsByUser(JSON.parse(role), id);
    const response = await getLessonsByUser(role, id);
    setLessons(response);
  };
  const canDeclineLesson = (lessonTime, lessonDate, thresholdHours) => {
    const lessonDateTimeString = `${formatDateWithSlashes(
      lessonDate
    )}T${lessonTime}`;
    const lessonDateTime = new Date(lessonDateTimeString);
    // const lessonDate = new Date(lessonTime);
    // console.log(lessonDateTime);

    const currentDate = new Date();
    const hoursDifference = (lessonDateTime - currentDate) / 1000 / 60 / 60; // Convert milliseconds to hours
    return hoursDifference >= thresholdHours;
  };
  const handleFeedbackChange = (lessonId, value) => {
    setFeedback((prevFeedback) => ({ ...prevFeedback, [lessonId]: value }));
  };
  function formatDateWithSlashes(date) {
    date = new Date(date);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based, so add 1
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }
  const handleSetTrialLessonSchedule = async () => {
    // console.log(selectedTime);

    const updatedLesson = {
      ...selectedLesson,
      date: selectedDate,
      start_time: selectedTime,
      status: "accepted",
    };

    // Update state first (optional, but ensures UI updates immediately)
    // console.log(updatedLesson);

    setSelectedLesson(updatedLesson);

    const response = await updateLesson(selectedLesson?.id, updatedLesson);
    if (response.success) {
      setLessons((prevLessons) =>
        prevLessons.map((lesson) =>
          lesson.id === selectedLesson?.id ? response.data : lesson
        )
      );
      setChooseLessonTimeModalVisible(false);
      setProposedOptions([]);
      setToastShown(true);
      toast.success("Lesson scheduled successfully");
    } else {
      toast.error("Failed to schedule lesson");
    }
  };

  return (
    <div className="student-lessons container">
      <h1>Your Lessons</h1>
      <div className="student-lessons-cards-container">
        {lessons?.length === 0 ? (
          <p>No lessons available.</p>
        ) : (
          lessons?.map((lesson) => (
            <>
              <Card
                key={lesson.id}
                className="lesson-card mx-2"
                title={
                  lesson?.order?.is_trial_lesson_order === true
                    ? `Trial Lesson ${
                        lesson.start_time && lesson.status === "accepted"
                          ? "On " + formatDate(lesson.date)
                          : "Not Scheduled"
                      }`
                    : `Lesson on ${formatDate(lesson.date)}`
                }
                // title={`Lesson on ${new Date(lesson.date).toLocaleDateString()}`}
              >
                <p>
                  <strong>Instructor:</strong>{" "}
                  {lesson?.instructor?.name ?? "Not assigned"}
                </p>
                <p>
                  <strong>Start Time:</strong>{" "}
                  {formatTimeTo12HourFormat(lesson?.start_time)}
                </p>
                <p>
                  <strong>Duration:</strong> {formatDuration(lesson?.duration)}{" "}
                  {/* minutes */}
                </p>
                {!lesson?.start_time &&
                  lesson?.order?.is_trial_lesson_order &&
                  lesson?.order?.proposed_schedule && (
                    <Button
                      label="Set Time and Date"
                      className="btn-primary"
                      onClick={() => {
                        setChooseLessonTimeModalVisible(true);
                        setProposedOptions(lesson?.order?.proposed_schedule);
                        setSelectedLesson(lesson);
                      }}
                    />
                  )}
                {lesson?.status === "waiting" &&
                  !lesson?.order?.is_trial_lesson_order && (
                    <div className="lesson-actions">
                      <Button
                        label="Accept"
                        className="btn btn-success"
                        onClick={() => handleAction(lesson?.id, "accepted")}
                      />
                      <Button
                        label="Decline"
                        className="btn btn-warning"
                        onClick={() => handleAction(lesson?.id, "declined")}
                        disabled={
                          !canDeclineLesson(
                            lesson?.start_time,
                            lesson?.date,
                            lesson?.instructor?.decline_hours
                          )
                        }
                      />
                    </div>
                  )}
                {lesson.status === "completed" && (
                  <div className="feedback-section">
                    <p className=" fs-5 fw-bold ">Lesson Completed</p>
                    {/* <InputText
                    value={feedback[lesson.id] || ""}
                    onChange={(e) =>
                      handleFeedbackChange(lesson.id, e.target.value)
                    }
                    placeholder="Add feedback"
                  />
                  <Button label="Submit" className="w-full md:w-5rem" /> */}
                  </div>
                )}
              </Card>
              {!lesson?.start_time && lesson?.status !== "accepted" && (
                <Dialog
                  visible={chooseLessonTimeModalVisible}
                  // header="Choose Lesson Time"
                  header={"Choose Time and Date of Your Trial Lesson"}
                  headerStyle={{ textAlign: "center" }}
                  modal={true}
                  style={{ minWidth: "400px", maxWidth: "50vw" }}
                  onHide={() => setChooseLessonTimeModalVisible(false)}
                >
                  <div>
                    <div className="my-3">
                      {proposedOptions?.map((option, index) => (
                        <div key={index} className="p-field-radiobutton">
                          <RadioButton
                            inputId={`option-${index}`}
                            name="lessonTime"
                            value={option}
                            onChange={() => {
                              setSelectedDate(option?.date);
                              setSelectedTime(option?.startTime);
                            }}
                            checked={
                              selectedDate === option?.date &&
                              selectedTime === option?.startTime
                            }
                          />
                          <label htmlFor={`option-${index}`} className="ml-2">
                            Date: {formatDate(option?.date)} / Time:{" "}
                            {formatTimeTo12HourFormat(option?.startTime)}
                          </label>
                        </div>
                      ))}
                    </div>
                    <Button
                      label="Set Lesson Schedule"
                      className="p-button-success"
                      onClick={handleSetTrialLessonSchedule}
                    />
                  </div>
                </Dialog>
              )}
            </>
          ))
        )}
      </div>
    </div>
  );
};

export default StudentLessons;
